import { Unit } from '../types';

/**
 * Статичный справочник единиц измерения
 */
export const MOCK_UNITS: Unit[] = [
  {
    id: '1',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Штука',
    short_name: 'шт'
  },
  {
    id: '2',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Килограмм',
    short_name: 'кг'
  },
  {
    id: '3',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Грамм',
    short_name: 'г'
  },
  {
    id: '4',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Тонна',
    short_name: 'т'
  },
  {
    id: '5',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Литр',
    short_name: 'л'
  },
  {
    id: '6',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Миллилитр',
    short_name: 'мл'
  },
  {
    id: '7',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Метр',
    short_name: 'м'
  },
  {
    id: '8',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Сантиметр',
    short_name: 'см'
  },
  {
    id: '9',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Квадратный метр',
    short_name: 'м²'
  },
  {
    id: '10',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Кубический метр',
    short_name: 'м³'
  },
  {
    id: '11',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Упаковка',
    short_name: 'упак'
  },
  {
    id: '12',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Коробка',
    short_name: 'кор'
  },
  {
    id: '13',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Набор',
    short_name: 'наб'
  },
  {
    id: '14',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Пара',
    short_name: 'пар'
  },
  {
    id: '15',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Услуга',
    short_name: 'усл'
  }
];
